import React from 'react';
import classNames from 'classnames';

import * as Types from 'types';

type Props = {
  title?: string;
  children: React.ReactNode;
} & Types.Styleable;

export const SidebarWidget = (props: Props) => (
  <div
    style={props.style}
    className={classNames('sidebar-widget mb-2', props.className)}
  >
    {props.title && (
      <div className='sidebar-widget__title key-value key-value--vault mb-1'>
        {props.title}
      </div>
    )}
    <div className='sidebar-widget__content'>{props.children}</div>
  </div>
);
